export const USERS_STATUS = [
  {
    id: 'active',
    title: 'status.header.users.active',
    color: 'green6',
    filled: true,
  },
  {
    id: 'pending',
    title: 'status.header.users.pending',
    color: 'gray6',
    filled: false,
  },
  {
    id: 'expired',
    title: 'status.header.users.expired',
    color: 'red6',
    filled: true,
  },
];

function normalizeUserStatus(user) {
  const rawStatus = (user?.status || user?.state || '').toLowerCase();

  return USERS_STATUS.some(({ id }) => id === rawStatus) ? rawStatus : '';
}

export function getUsersStatusCounts(users) {
  return users.reduce((counts, user) => {
    const status = normalizeUserStatus(user);

    return {
      ...counts,
      totalUsers: counts.totalUsers + 1,
      ...(status && { [status]: (counts[status] || 0) + 1 }),
    };
  }, {
    totalUsers: 0,
    active: 0,
    pending: 0,
    expired: 0,
  });
}
